<template>
  <div :class="['image-view__holder', { 'image-view__holder--empty': !src }]">
    <v-img :src="src" class="image-view__img"/>

    <div v-if="src" class="image-view__preview">
      <v-img :src="src"/>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "VImageView",

  props: {
    path: {
      type: String,
      required: true
    }
  },

  data: () => ({
    src: ''
  }),

  mounted() {
    firebase.storage().ref(this.path).getDownloadURL().then(result => {
      this.src = result;
    }, error => {
      console.warn(error.message);
    });
  }
}
</script>

<style scoped lang="scss">
.image-view {
  $self: &;

  &__holder {
    position: relative;
    width: 50px;
    height: 50px;
    cursor: zoom-in;

    &:hover {
      #{$self}__preview {
        display: block;
      }
    }

    &--empty {
      cursor: default;
    }
  }

  &__img {
    width: 50px;
    height: 50px;
    object-fit: cover;
  }

  &__preview {
    position: fixed;
    top: 70px;
    right: 15px;
    display: none;
    width: 250px;
    height: auto;
    padding: 20px 0;
    background: #fefefe;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    z-index: 20;
    pointer-events: none;

    :where(img) {
      width: 100%;
      height: auto;
    }
  }
}
</style>